import type { Category } from '../types';
import { setUpYourBusiness } from './setUpYourBusiness';
import { taxes101 } from './taxes101';
import { deductions } from './deductions';
import { recordkeeping } from './recordkeeping';
import { insurance } from './insurance';
import { safety } from './safety';
import { reportingAProblem } from './reportingAProblem';
import { foodSafety } from './foodSafety';
import { gear } from './gear';
import { payStatement } from './payStatement';
import { buildingYourBook } from './buildingYourBook';
import { accident } from './accident';

/** Order = the deck's §10 card order (business half, then "On the job"). */
export const CATEGORIES: Category[] = [
  setUpYourBusiness,
  taxes101,
  deductions,
  recordkeeping,
  insurance,
  safety,
  reportingAProblem,
  foodSafety,
  gear,
  payStatement,
  buildingYourBook,
  accident,
];

export const categoryBySlug = (slug: string): Category | undefined => CATEGORIES.find((c) => c.slug === slug);
export const guideByPath = (categorySlug: string, guideSlug: string) => {
  const c = categoryBySlug(categorySlug);
  const g = c?.guides.find((x) => x.slug === guideSlug);
  return c && g ? { category: c, guide: g } : undefined;
};
